import { createContext, createElement, useContext, useEffect, useMemo, useState } from "react";

const KEY = "scratchs3d_cart";
const CartCtx = createContext(null);

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const keyOf = (slug, color) => `${slug}::${color || ""}`;
    const add = (product, color, qty = 1) => {
      setItems((prev) => {
        const k = keyOf(product.slug, color);
        const found = prev.find((i) => i.key === k);
        if (found) return prev.map((i) => (i.key === k ? { ...i, qty: i.qty + qty } : i));
        return [...prev, { key: k, slug: product.slug, name: product.name, price: product.price, image: product.image, color, qty }];
      });
      setOpen(true);
    };
    const setQty = (key, qty) =>
      setItems((prev) => (qty < 1 ? prev.filter((i) => i.key !== key) : prev.map((i) => (i.key === key ? { ...i, qty } : i))));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.qty, 0);
    const total = items.reduce((s, i) => s + i.qty * i.price, 0);
    return { items, add, setQty, clear, count, total, open, setOpen };
  }, [items, open]);

  return createElement(CartCtx.Provider, { value }, children);
};

export const useCart = () => useContext(CartCtx);
